import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import image1 from "../../Assets/Images/seekjob/sec2.png";
import image2 from "../../Assets/Images/seekjob/sec1.png";
import image3 from "../../Assets/Images/seekjob/sec3.png";

const stagger = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.7,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

function ImageButtonSection() {
  const cardData = [
    {
      id: 1,
      imageUrl: image1,
      altText: "Description for Image 1",
      buttonText: "For Job Seekers",
      buttonLink: "/job-seeker",
    },
    {
      id: 2,
      imageUrl: image3,
      altText: "Description for Image 2",
      buttonText: "For Career Centers",
      buttonLink: "/career-centers",
    },
    {
      id: 3,
      imageUrl: image2,
      altText: "Description for Image 3",
      buttonText: "For Employers",
      buttonLink: "/employer",
    },
  ];

  return (
    <section className="tw-relative tw-z-50 tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-bg-transparent tw-mt-8 sm:tw-mt-12 lg:tw-mt-8">
      <div className="tw-container tw-mx-auto">
        <motion.h2
          className="tw-text-center tw-text-[32px] sm:tw-text-[66px] tw-font-semibold tw-mb-4 tw-text-white"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          custom={0.2}
        // variants={stagger}
        >
          Our Playground
        </motion.h2>

        <p className="tw-text-center tw-text-[17px] sm:tw-text-[19px] tw-text-white tw-mb-12">
          Everything you need, nothing you don't.
        </p>

        <div className="tw-flex tw-flex-col lg:tw-flex-row tw-justify-center tw-gap-8 tw-items-start">
          {cardData.map((card, index) => (
            <motion.div
              key={card.id}
              className="tw-flex tw-flex-col tw-items-start tw-w-full lg:tw-w-1/3"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              custom={index + 1}
            // variants={stagger}
            >
              <div
                className="tw-relative tw-w-full tw-overflow-hidden tw-rounded-lg tw-group"
                style={{ paddingBottom: "66.66%" }}
              >
                <img
                  src={card.imageUrl}
                  alt={card.altText}
                  className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover tw-rounded-lg tw-transform tw-transition-transform tw-duration-500 group-hover:tw-scale-110"
                />
              </div>

              <Link
                to={card.buttonLink}
                className="tw-mt-4 tw-inline-block tw-bg-gradient-to-r tw-from-[#0843FE] tw-to-[#4995FB] tw-text-white tw-font-medium tw-py-2 tw-px-4 tw-rounded-md tw-transition tw-duration-300 tw-ease-in-out"
              >
                {card.buttonText}
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ImageButtonSection;
